import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { LeftOutlined, PlusOutlined, RightOutlined } from '@ant-design/icons';
import { Col, Table, Row, Divider, Alert } from 'antd';
import { ExcelIcon } from 'icons';
import { Link } from 'react-router-dom';
import Filters from 'components/filters';
import { useTranslation } from 'react-i18next';
import useCalendars from '../useCalendars';
import useFilters from '../../useFilters';

const MainPage = () => {
  const {
    columns,
    calendars,
    setDate,
    avilableDates,
    loading,
    handleDownloadExcel,
  } = useCalendars();
  const { t } = useTranslation();
  const { searchParams, filters } = useFilters(true);

  const by_shopping_center = searchParams.get('by_shopping_center');

  return (
    <>
      <PageHeader title={t('ANALYTICS CALENDAR').toUpperCase()}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              icon={<ExcelIcon fill={'#fff'} />}
              onClick={handleDownloadExcel}
              loading={loading}
              disabled={!by_shopping_center}
            >
              {t('Export')}
            </Button>
          </Col>
          <Col>
            <Link to={'new'}>
              <Button big icon={<PlusOutlined />}>
                {t('NUOVO')}
              </Button>
            </Link>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters} />
        <br />
        {!by_shopping_center && (
          <Alert
            message={t('Outlet Village non può essere lasciato in bianco')}
            type='warning'
          />
        )}
        {by_shopping_center && (
          <>
            <Divider />
            <Table
              loading={loading}
              columns={columns}
              dataSource={calendars}
              pagination={{
                pageSize: 1000,
                position: ['bottomCenter'],
                hideOnSinglePage: true,
                showSizeChanger: false,
              }}
            />
          </>
        )}
      </div>
      {by_shopping_center && (
        <Row gutter={16} justify={'center'}>
          <Col>
            <Button
              loading={loading}
              onClick={() => {
                setDate(avilableDates.prev_date);
              }}
              big
              icon={<LeftOutlined />}
            >
              {t('Mese pre.')}
            </Button>
          </Col>
          <Col>
            <Button
              loading={loading}
              big
              onClick={() => {
                setDate(avilableDates.next_date);
              }}
            >
              {t('Prossimo mese')}
              <RightOutlined />
            </Button>
          </Col>
        </Row>
      )}
      <br />
    </>
  );
};

export default MainPage;
